import React from 'react'
import { StyledSwitch } from './Switch.styles'

export const Switch = ({
  id,
  checked,
  onChange,
}: {
  id: string
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}): JSX.Element => {
  return <StyledSwitch id={id} checked={checked} onChange={onChange} />
}
